// extracted by mini-css-extract-plugin
module.exports = {"leaderboardHeading":"style_leaderboardHeading__2-8Iz"};